import IBasicLookupFieldProps, { IBasicLookupFieldHandle, ILookupFieldColumn } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';
import { customerLookupConstants } from './CustomLookups/customerLookup.constants';
import { productBinMasterLookupConstants } from './CustomLookups/productBinMasterLookup.constants';
import { productPurchaseOrderLineLookupConstants } from './CustomLookups/ProductPurchaseOrderLineLookup.constants';
import { warehouseProductBinLotLookupConstants } from './CustomLookups/warehouseProductBinLotLookup.constants';
import { supplierLookupConstants } from './CustomLookups/supplierLookup.constants';
import { salesOrderLookupConstants } from './CustomLookups/salesOrderLookup.constants';
import { salesInvoiceEnquiryLookupConstants } from './CustomLookups/salesInvoiceEnquiryLookup.constants';
import { customerQuoteEnquiryLookupConstants } from './CustomLookups/customerQuoteLookup.constants';
import { customerProductLookupConstants } from './CustomLookups/customerProductLookup.constants';
import { CustomerCreditReasonConstants } from './CustomLookups/CustomerCreditReason.constants';

export const FIXED_DEFAULT_TYPE_BATCH_SIZE = 100;
export const DEFAULT_BATCH_SIZE = 100;

export const lookupConstants = {
    Customer: customerLookupConstants,
    ProductPurchaseOrderLine: productPurchaseOrderLineLookupConstants,
    WarehouseProductBinLot: warehouseProductBinLotLookupConstants,
    ProductBinMaster: productBinMasterLookupConstants,
    Supplier: supplierLookupConstants,
    SalesOrder: salesOrderLookupConstants,
    SalesInvoice: salesInvoiceEnquiryLookupConstants,
    SalesInvoiceSearch: salesInvoiceEnquiryLookupConstants,
    CustomerQuote: customerQuoteEnquiryLookupConstants,
    CustomerProduct: customerProductLookupConstants,
    CustomerCreditReason: CustomerCreditReasonConstants,
};
export interface ILookupFieldColumnEx extends ILookupFieldColumn {
    hideInV2?: boolean;
    hideInV3?: boolean;
}
export interface IScopeOptions {
    isCustomerSupplierScoped?: boolean;
    isCustomerScoped?: boolean;
    isWorksaleScoped?: boolean;
    isProductScoped?: boolean;
    isEntityScoped?: boolean;
    isWidgetTypeScoped?: boolean;
    isSupplierScoped?: boolean;
    isWarehouseSupplierScoped?: boolean;
    isWarehouseProductScoped?: boolean;
    isWarehouseProductBinScoped?: boolean;
    isProductWarehouseSupplierScoped?: boolean;
    isDashboardTypeScoped?: boolean;
}
export interface IBasicLookupActionFieldProps extends Omit<IBasicLookupFieldProps, 'valueField' | 'displayField' | 'descriptionField' | 'column1Field' | 'column2Field'>, IScopeOptions {
    lookupName: string;
    params?: any;
    isLookupTypeFixed?: boolean;
    valueField?: string;
    displayField?: string;
    descriptionField?: string;
    column1Field?: string;
    column2Field?: string;
    isV2?: boolean;
    isV3?: boolean;
    fieldRef?: React.Ref<IBasicLookupFieldHandle>;
    searchScreenAPIParms?: any;
    onValueChange?(value: string): void;
    setFieldAsyncError?(fieldName: string, error: string): void;
}

export interface ICustomLookupColumn {
    dataField: string;
    caption: string;
    allowResizing: boolean;
    minWidth: number;
    width?: number;
    fixed: boolean;
    hideInV3?: boolean | null;
    hideInV2?: boolean | null;
    allowSorting?: boolean;
}

export interface ICustomSearchScreenDialogStyle {
    width: number | string;
    maxWidth: number | string;
    height: number | string;
    maxHeight: number | string;
}
export interface ICustomTabbedLookupOptions {
    isTabbedLookup: boolean;
    showSummaryPanel?: boolean | false;
    lookupScreenTitle?: string;
    searchScreenTitle?: string;
}
export interface ICustomLookupOptions {
    columns?: ICustomLookupColumn[];
    dialogStyle?: ICustomSearchScreenDialogStyle;
    hideColumnHeaders?: boolean | null;
    disableGridColumnLines?: boolean | null;
    dataPrefix?: string | null;
    tabbedLookup?: ICustomTabbedLookupOptions;
    shouldEnterBehaveAsTab?: boolean | false;
    dataGridSorting?: string;
}
